import { useMemo } from 'react';
import { getSubGoalName } from '../utils/dataConversion';

export const useDataEntryMemoized = ({
  studentGoalsData,
  studentId,
  dataPoints,
  subGoalIndex,
  allGoalData,
  studentDataPoints,
  selectedDate,
}) => {
  const filteredGoals = useMemo(() => {
    return studentGoalsData.filter(
      (goal) => (goal.id || goal?.studentData?.StudentID) === studentId
    );
  }, [studentGoalsData, studentId]);

  const goalCollectionID = useMemo(() => {
    return studentDataPoints?.find((dp) => dp.date === selectedDate)
      ?.goalCollectionId;
  }, [studentDataPoints, selectedDate]);

  const displayedSubGoalIndex = useMemo(() => {
    if (subGoalIndex) return subGoalIndex;
    if (dataPoints && dataPoints.length > 0) {
      const cg = dataPoints[0]?.currentGoal;
      if (cg && cg !== 'main') return cg;
    }
    return null;
  }, [subGoalIndex, dataPoints]);

  const subGoalName = useMemo(() => {
    return getSubGoalName(displayedSubGoalIndex, allGoalData);
  }, [displayedSubGoalIndex, allGoalData]);

  return {
    filteredGoals,
    goalCollectionID,
    displayedSubGoalIndex,
    subGoalName,
  };
};
